import { render, staticRenderFns } from "./MilestoneBoardGlobalList.vue?vue&type=template&id=0b09c972&"
import script from "./MilestoneBoardGlobalList.vue?vue&type=script&lang=js&"
export * from "./MilestoneBoardGlobalList.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneBoardGlobalList.vue?vue&type=style&index=0&id=0b09c972&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports